"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var apps_shared_1 = require("@l2p/apps-shared");
var Step2 = function () {
    var t = (0, next_intl_1.useTranslations)('translation');
    var closeWindow = (0, apps_shared_1.useCloseModal)();
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.title, dangerouslySetInnerHTML: {
                __html: t.raw('checkYourEmailTitle'),
            } }),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.description, dangerouslySetInnerHTML: {
                __html: t.raw('checkYourEmailDescription'),
            } }),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonContainer },
            react_1.default.createElement(ui_components_1.FixedButton, { text: "upper", width: "200px", onClick: closeWindow }, t('ok')))));
};
exports.default = Step2;
